import script from "./Carousel.vue?vue&type=script&setup=true&lang=js"
export * from "./Carousel.vue?vue&type=script&setup=true&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=358080b3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-358080b3"]])

export default __exports__